import { KeyValue } from '@/main/models/common';

export enum DomainUsersByCompanyTypes {
  GET_DOMAIN_USERS_BY_COMPANY = '@domainUsersByCompany/GET_DOMAIN_USERS_BY_COMPANY',
  SAVE_DOMAIN_USERS_BY_COMPANY = '@domainUsersByCompany/SAVE_DOMAIN_USERS_BY_COMPANY',
  RESET_REDUCER_DOMAIN_USERS_BY_COMPANY = '@domainUsersByCompany/RESET_REDUCER_DOMAIN_USERS_BY_COMPANY'
}

export interface DomainUsersByCompanyState {

  readonly domainUsersByCompany: {
  data: KeyValue[] | null;
  isLoading: boolean;
  isError: boolean;
  errorMessages: string[] | null;
  }
}

export interface GetDomainUsersByCompany {
  type: typeof DomainUsersByCompanyTypes.GET_DOMAIN_USERS_BY_COMPANY;
  payload: string;
}

export interface SaveDomainUsersByCompany {
  type: typeof DomainUsersByCompanyTypes.SAVE_DOMAIN_USERS_BY_COMPANY;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerDomainUsersByCompany {
  type: typeof DomainUsersByCompanyTypes.RESET_REDUCER_DOMAIN_USERS_BY_COMPANY;
}



export type DomainUsersByCompanyActionTypes =
  | GetDomainUsersByCompany
  | SaveDomainUsersByCompany
  | ResetReducerDomainUsersByCompany;